<template>
  <div>
    <!--Breadcrumb button-->
    <breadcrumb-button>
      <template #beforeDropdown>
        <b-button variant="success" class="btn-icon" v-b-tooltip v-bind:title="$t('operations.add')" @click="onSmtpSelected(null)">
          <i class="fa-solid fa-user-plus"></i>
        </b-button>
      </template>
      <template #items>
        <b-dropdown-item @click="openColumnsModal">
          <feather-icon
              icon="CheckSquareIcon"
              size="16"
          />
          <span class="align-middle ml-50">{{ $t('columns.self') }}</span>
        </b-dropdown-item>
      </template>
    </breadcrumb-button>
    <!--Filters-->
    <filter-card  v-model="filter" v-bind:fields="filterFields" search/>
    <!--Table Card-->
    <b-card no-body>
      <b-card-header class="pb-50">
        <h5>{{$t("menu.smtps")}}</h5>
      </b-card-header>
      <b-card-body>
        <smtps-table ref="smtpTable" v-bind:filters="filter" v-bind:columns="columns" :has-selection="false" @selected="onSmtpSelected" :lazy="true"/>
      </b-card-body>
    </b-card>
    <!--Modal-->
    <columns-modal ref="columns-modal" column-key="smtps" v-model="columns"
                   v-bind:columns-names="columnsNames" />
    <smtp-modal ref="smtp-modal" />
  </div>
</template>

<script>

import { mapActions, mapGetters } from 'vuex'
import BreadcrumbButton from '@/components/widget/breadcrumbButton'
import SmtpSearchRequest from '@/model/smtp/SmtpSearchRequest'
import ColumnsModal from '@/components/modal/columnsModal'
import Smtp from '@/model/smtp/Smtp'
import mixinPermissions from '@/components/mixin/mixinPermissions'
import mixinBase from '@/components/mixin/mixinBase'
import SmtpModal from '@/components/modal/smtpModal'
import FilterCard from '@/components/widget/FilterCard'
import SmtpFilterFields from '@/model/filter/SmtpFilterFields'
import SmtpsTable from '@/components/tables/SmtpsTable'

export default {
  name: 'SmtpsView',
  components: {SmtpsTable, FilterCard, SmtpModal, ColumnsModal, BreadcrumbButton },
  mixins: [mixinBase,mixinPermissions],
  data() {
    return {
      columnsNames: Object.keys(Smtp()),
      filter: SmtpSearchRequest(),
      filterLoaded: false,
      columns: [],
      filterFields: null,
    }
  },
  async created() {
    await this.refreshData()
    this.filterFields = SmtpFilterFields();
  },
  computed: {
    ...mapGetters('data', ['allOrganizations']),
  },
  methods: {
    ...mapActions('smtp', ['refreshData']),
    openColumnsModal() {
      this.$refs['columns-modal'].showModal()
    },
    onSmtpSelected(selectedId) {
      this.$refs['smtp-modal'].showModal(selectedId)
    },
  }
}
</script>

<style>
.style-chooser .vs__search::placeholder,
.style-chooser .vs__dropdown-toggle,
.style-chooser .vs__dropdown-menu {
  background: #dfe5fb;
  border: none;
  color: #394066;
  text-transform: lowercase;
  font-variant: small-caps;
  height: 10px;
}
</style>
